import React from "react";

function Bar({ width, height = 12, style = {} }) {
  return (
    <div
      className="sk-bar"
      style={{ width, height, borderRadius: 6, display: "block", ...style }}
    />
  );
}

function CardSkeleton({ rightContent, leftHeight = 80 }) {
  return (
    <div className="st-card" style={{ marginBottom: 16 }}>
      <div className="st-card-row">
        {/* Left column */}
        <div className="st-card-left">
          <Bar width={120} height={13} style={{ marginBottom: 10 }} />
          <Bar width="90%" height={9} style={{ marginBottom: 6 }} />
          <Bar width="70%" height={9} />
        </div>
        {/* Right column */}
        <div className="st-card-right">
          {rightContent}
        </div>
      </div>
    </div>
  );
}

function RadioGroupSkeleton() {
  return (
    <div style={{ marginBottom: 24 }}>
      <Bar width={130} height={9} style={{ marginBottom: 12 }} />
      <div style={{ display: "flex", gap: 8 }}>
        <Bar width={100} height={36} style={{ borderRadius: 8 }} />
        <Bar width={100} height={36} style={{ borderRadius: 8 }} />
      </div>
    </div>
  );
}

function ToggleRowSkeleton() {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 16, padding: "20px 0", borderBottom: "1px solid var(--ti-border)" }}>
      <Bar width={40} height={22} style={{ borderRadius: 100, flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <Bar width={160} height={13} style={{ marginBottom: 8 }} />
        <Bar width="85%" height={9} style={{ marginBottom: 4 }} />
        <Bar width="60%" height={9} />
      </div>
    </div>
  );
}

export default function SettingsSkeleton() {
  return (
    <>
      {/* Workspace header card */}
      <div className="st-card" style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 28, padding: 28 }}>
          <Bar width={96} height={96} style={{ borderRadius: 16, flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <Bar width={110} height={9} style={{ marginBottom: 10 }} />
            <Bar width="100%" height={44} style={{ borderRadius: 8 }} />
          </div>
        </div>
      </div>

      {/* Team member rights */}
      <CardSkeleton rightContent={
        <>
          <RadioGroupSkeleton />
          <RadioGroupSkeleton />
          <RadioGroupSkeleton />
        </>
      } />

      {/* Default billing */}
      <CardSkeleton rightContent={<RadioGroupSkeleton />} />

      {/* Rates & Currency */}
      <CardSkeleton rightContent={
        <>
          <Bar width={110} height={9} style={{ marginBottom: 12 }} />
          <Bar width={240} height={40} style={{ borderRadius: 8 }} />
        </>
      } />

      {/* Time restrictions */}
      <CardSkeleton rightContent={
        <>
          <ToggleRowSkeleton />
          <ToggleRowSkeleton />
        </>
      } />

      {/* Time rounding */}
      <CardSkeleton rightContent={<ToggleRowSkeleton />} />

      {/* Notifications */}
      <CardSkeleton rightContent={
        <>
          <ToggleRowSkeleton />
          <ToggleRowSkeleton />
          <ToggleRowSkeleton />
          <ToggleRowSkeleton />
        </>
      } />

      {/* Workspace ownership */}
      <CardSkeleton rightContent={
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <Bar width={44} height={44} style={{ borderRadius: 12, flexShrink: 0 }} />
          <div>
            <Bar width={130} height={13} style={{ marginBottom: 8 }} />
            <Bar width={90} height={9} />
          </div>
        </div>
      } />
    </>
  );
}
